import { GDFHotPollyTypes, GDFHotPolyHiRecordNormal, GDFHotPolyRecordNormal } from '../../gdf/type';
import { getCopyButtonComponent } from '../copy-button';

export default function WatchesWarningsProperties({ record }: { record: GDFHotPolyHiRecordNormal | GDFHotPolyRecordNormal }) {
    const Button = getCopyButtonComponent();
    return (
        <div>
            {Button && (
                <div className="pb-2 d-flex justify-content-end">
                    <Button getText={() => record.detail} />
                </div>
            )}
            {(record.polyType === GDFHotPollyTypes.warning_tornado || record.polyType === GDFHotPollyTypes.warning_tstorm) && (
                <div>Warning box label: {record.label}</div>
            )}
            <pre className="p-2 mt-2 secondary-bg-color" style={{ fontFamily: 'monospace' }}>
                {record.detail}
            </pre>
        </div>
    );
}
